import immutable from 'immutable';
import SearchFieldsStore from 'stores/search/SearchFieldsStore';
import SearchStore from 'stores/SearchStore';
import CallActions from 'actions/CallActions';

/**
 * @deprecated this is just a grab bag of mostly unrelated code.
 * Avoid using this if possible in new code.
 */
export default class ComponentUtils {
  static hasRemovePermissionOnLibrary(library) {
    return library && immutable.List(library.permissions).includes('remove');
  }

  libraryPermissionsForUser(user, shares) {
    let libraryPermissionsForUser = {
      admin: false,
      create_tags: false,
      add: false,
      remove: false,
    };
    shares.forEach(share => {
      // Iterate through all share configurations for the current library and decide whether this.props.user is
      // allowed to manage its sharing or not
      if (
        share.type === 'account' ||
        (share.type === 'user' && share.id === user.id) ||
        (share.type === 'team' && share.id === user.team_id) ||
        (share.type === 'department' && share.id === user.department_id)
      ) {
        if (share.admin_permission) {
          libraryPermissionsForUser.admin = true;
        }
        if (share.create_tags_permission) {
          libraryPermissionsForUser.create_tags = true;
        }
        if (share.add_permission) {
          libraryPermissionsForUser.add = true;
        }
        if (share.remove_permission) {
          libraryPermissionsForUser.remove = true;
        }
      }
    });
    return libraryPermissionsForUser;
  }

  /** Rerun the current search to refresh the search results */
  refreshCurrentSearch() {
    const searchExpression = SearchFieldsStore.getState().get('searchExpression');
    const term = SearchStore.getState().get('searchTerm');
    if (term.length > 0 && searchExpression) {
      CallActions.termFieldsSearch.defer(term, searchExpression);
    } else {
      CallActions.directTextSearch.defer(term);
    }
  }
}
